import { useUser } from "contexts/userContext/userContext";
import React, { useState, useEffect } from "react";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useParams } from "react-router-dom";

const useJumboFormSettings = ({ setEmbedUser, setLoading }) => {
  const { getUserData, isPremium } = useUser();
  const userData = getUserData();
  const params = useParams();

  const [formProps, setFormProps] = useState({
    EmbedForm: {
      Embed_Dynamic_Id: 0,
      Embed_Dynamic_Width: 460,
      Embed_Dynamic_Height: 0,
      Embed_Dynamic_Culture: "",
      Embed_Dynamic_Inner_Title: "",
      Embed_Dynamic_Display_Title: "",
      Embed_Dynamic_Description: "",
      Embed_Dynamic_Image_Url: "",
      Embed_Dynamic_Body: "",
      Embed_Dynamic_Recipients: "",
      Embed_Dynamic_Upload_Files_limit: "",
      Embed_Dynamic_Size_Id: "",
      Embed_Dynamic_Manually_Delete: "",
      Embed_Dynamic_Delete_Days: "",
      Embed_Dynamic_Send_Lead: "",
      Embed_Dynamic_Send_Download: "",
      Embed_Dynamic_Send_Copy: "",
      Embed_Dynamic_End_Download_Link: "",
      Embed_Dynamic_End_Send_Button: "",
      Embed_Dynamic_End_Redirect: "",
      Embed_Dynamic_End_Redirect_Url: "",
      Embed_Dynamic_SetPassword: "",
      Embed_Dynamic_Password: "",
      Embed_Dynamic_Formats_Action: "",
      Embed_Dynamic_Formats: "",
      Embed_Dynamic_Url: "",
      Embed_Dynamic_Buttons_Color_Code: "",
      Embed_Dynamic_Background_Color_Code: "",
      Embed_Dynamic_Hide_Image: "",
    },
  });

  const getNumOfEmbedDynamicForms = async () => {
    setLoading(true);
    const parameters = {
      onlyActiveForms: true,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetNumOfEmbedDynamicForms",
      parameters
    );
    if (response.status === "success") {
      setLoading(false);
      if (response.data) {
        if (!isPremium()) {
          if (response.data > 0) {
            setEmbedUser(false);
          } else {
            setEmbedUser(true);
          }
        }
      } else {
        setEmbedUser(true);
      }
    } else {
      setLoading(false);
    }
  };

  //check if user is Embed User
  useEffect(() => {
    if (params && params.EmbedDynamicId) {
      setEmbedUser(true);
    } else {
      if (userData && userData.UserId !== undefined) {
        if (isPremium()) {
          setEmbedUser(true);
        } else {
          getNumOfEmbedDynamicForms();
        }
      }
    }
  }, [userData]);

  return <></>;
};

export default useJumboFormSettings;
